/**
 * Phase 45 Plan 45-08 — task time entries API client.
 *
 * Backend contract (45-08 — new in this plan):
 *   GET /api/tasks/:taskId/entries → TaskTimeEntryDto[]
 *
 * Read-only feed for TaskDetailSlideOver. Logging continues via the
 * timesheet flow (LogTimePopover on MyTasks); the slide-over is display-
 * only here per the design hand-off.
 */
import { apiGet } from './client';

export interface TaskTimeEntryDto {
  id: number;
  date: string | null;
  hours: number | null;
  description: string | null;
  state: string | null;
  user: {
    id: number;
    firstName: string | null;
    lastName: string | null;
  } | null;
}

export async function fetchTaskTimeEntries(
  taskId: number,
): Promise<TaskTimeEntryDto[]> {
  const response = await apiGet<{ data: TaskTimeEntryDto[] }>(
    `/tasks/${taskId}/entries`,
  );
  return response.data;
}
